import * as React from 'react';
import { Dictionary } from 'underscore';

import { ExplorerEmptyState } from '../../../../app/spaces/Components/ExplorerEmpyState';
import { Messages } from '../../../../codegen/Localize';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { DataType } from '../../../types/DetailEnums';
import { ValueConcept } from '../../../types/ValueConcept';
import { valueConceptMatchesSearch } from '../../../utils/searchUtils';
import { DataRoleValuesAndSynonymsList } from './DataRoleValuesAndSynonymsList';
import { LegacyDataRoleValuesList } from './LegacyDataRoleValuesList';

const testId = 'values-section-values-grid';

export interface ValuesSectionValuesGridProps {
  readonly dataTypes: ReadonlyArray<DataType>;
  readonly valuesList: ReadonlyArray<ValueConcept>;
  readonly isEditing: boolean;
  readonly filterText: string;
  readonly resetFilterText: () => void;
  readonly valueCount: number;
  editedValueConcepts: Dictionary<ValueConcept>;
  setEditedValueConcepts:  (valueConcepts: Dictionary<ValueConcept>) => void;
}

export const ValuesSectionValuesGrid = (props: ValuesSectionValuesGridProps) => {
  const filteredValues = props.valuesList.filter(v => valueConceptMatchesSearch(v, props.filterText));

  // If there are no values to be shown
  if(props.valueCount === 0) {
    return (
      <ExplorerEmptyState
          dataTestId={testId}
          iconUrl={''}
          primaryMessage={Messages.contentEmptyMessage()}
          secondaryMessage={''}
      />);
  }

  // If there are values, but all of them are filtered out
  if(filteredValues.length === 0) {
    return (
      <ExplorerEmptyState
        dataTestId={testId}
        iconUrl={imgPath('spaces_filter_large.svg')}
        primaryMessage={Messages.contentEmptyFilterMessage()}
        secondaryMessage={''}
        actionButtonMessage={Messages.contentEmptyClearFilters()}
        onActionButton={props.resetFilterText}
      />);
  }
  // If displaying and editing value synonyms is enabled
  if(FeatureFlags.dataRolesEditValueSynonymsEnabled && props.dataTypes.indexOf('STRING') !== -1) {
    return (
      <DataRoleValuesAndSynonymsList
        valueConcepts={props.valuesList}
        isEditing={props.isEditing}
        filterText={props.filterText}
        editedValueConcepts={props.editedValueConcepts}
        setEditedValueConcepts={props.setEditedValueConcepts}
      />);
  }

  return (
    <LegacyDataRoleValuesList
      valuesList={props.valuesList.map(value => value.value)}
      isEditing={props.isEditing}
      filterText={props.filterText}
    />);
};
